import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import {  toast } from 'react-toastify';

const EditSchoolSubjectiveExamPricing = () => {
  const [schoolClassName, setSchoolClassName] = useState([]);
  const [schoolClassNameId, setSchoolClassNameId] = useState("");
  const [price, setPrice] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/subjective-exam/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Fetch the class names
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) => {
        const { data } = resp.data;
        setSchoolClassName(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleGoBack = () => {
    navigate("/subjective-exam-pricing");
  };

  const handleAddNewSSExamPricing = () => {
    navigate("/subjective-exam-pricing/add-school-subjective-exam-pricing");
  };

  const handleViewAllSSExamPricing = () => {
    navigate("/subjective-exam-pricing/all-school-subjective-exam-pricing");
  };

  const payload = {
    classId: schoolClassNameId,
    type: "school",
    price,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}/admin/pricing/subjective-exam/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        // alert("Price added successfully.");
        toast.success("Price updated successfully.")
      })
      .catch((error) => {
        console.log(error);
        alert("Error while adding Price");
        toast.error("Error while updating Price")
      });
  };
  return (
    <div id="exam-school-notes-inner-wrapper ">
      <div className="main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            display: "flex",
            fontSize: "25px",
            color: "#000",
          }}
        />
        <div className="exam-header-div">
          <h5>School Subjective Exam Pricing</h5>
          <div className="exam-btn-group">
            <button
              className="addNewNoteBtn"
              onClick={handleAddNewSSExamPricing}
            >
              + Add Price
            </button>
            <button
              className="viewAllNotesBtn"
              onClick={handleViewAllSSExamPricing}
            >
              All Price
            </button>
          </div>
        </div>

        <div className="form-container" id="form">
          <h4 className="note-detail">Edit Price Details </h4>
          <form onSubmit={handleSubmit} className="note-detail-form">
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Class Name</label>
              </div>
              <select
                className="select-dropdown"
                value={schoolClassNameId}
                onChange={(e) => setSchoolClassNameId(e.target.value)}
                required
              >
                <option value="">-Select Class-</option>
                {schoolClassName &&
                  schoolClassName.map((classes) => (
                    <option value={classes._id} key={classes._id}>
                      {classes?.className}
                    </option>
                  ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Price</label>
              <input
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter Price"
                required
              />
            </div>

            <div className="form1-btns">
              <button className="btn-save">Update</button>
              <button
                type="button"
                className="btn-cancel"
                onClick={handleGoBack}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditSchoolSubjectiveExamPricing;
